import { dew as _BackgroundFilterVideoFrameProcessorDelegateDew } from "../backgroundfilter/BackgroundFilterVideoFrameProcessorDelegate";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const BackgroundFilterVideoFrameProcessorDelegate_1 = __importDefault(_BackgroundFilterVideoFrameProcessorDelegateDew());
  /**
   * This class adds the functionality to allow for a set of unique observers to be added to the
   * video frame processor.
   */
  /** @internal */
  class BackgroundReplacementVideoFrameProcessorDelegate extends BackgroundFilterVideoFrameProcessorDelegate_1.default {}
  exports.default = BackgroundReplacementVideoFrameProcessorDelegate;
  //# sourceMappingURL=BackgroundReplacementVideoFrameProcessorDelegate.js.map
  return exports;
}